import moment = require("moment");
import { ComponentView } from "binder";
import { DateSelectorViewModel } from "./dateSelector-viewModel"

export class DateSelectorView extends ComponentView<DateSelectorViewModel>{
  
    GetViewUniqueId(): string {
        return "V-94722145-D490-4D17-A6F4-D141D696D7F6"
    }
    loadHtml(): string {
        let element = require('./dateSelector.html').default;
        let style = require('./dateSelector.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set date(v: moment.Moment) { 
        this._date = v; 
        if(this._dateSelector && v)
          this._dateSelector.setDate(v.valueOf());
        else if(this._dateSelector && v==null){
          this.clear();
        }
    } public get date(): moment.Moment { return this._date;} private _date: moment.Moment;
    public set startwithyear(v: boolean) { 
      this._startwithyear = v; 
      if(this._dateSelector){
        this.setOptions();
      }
    } public get startwithyear(): boolean { return this._startwithyear;} private _startwithyear: boolean;
    public set opentop(v: boolean) { 
      this._opentop = v; 
      this.setOptions();
      
    } public get opentop(): boolean { return this._opentop;} private _opentop: boolean;
    
    private _dateSelector;

    setOptions(){
      if(this._dateSelector==null) return;
      this._dateSelector.options = this.getOptions();
    }
    getOptions():any{
      return {
        "inline": false,
        "format": "YYYY/MM/DD",
        "viewMode": this.startwithyear==true ? 'year' : "day",
        "initialValue": false,
        "autoClose": true,
        "position": "auto",
        "altFormat": "lll",
        "altField": "#altfieldExample",
        "onlyTimePicker": false,
        "onlySelectOnDate": true,
        "calendarType": "persian",
        "inputDelay": 800,
        "observer": false,
        "calendar": {
          "persian": {
            "locale": "fa",
            "showHint": true,
            "leapYearMode": "astronomical"
          },
          "gregorian": {
            "locale": "en",
            "showHint": true
          }
        },
        "navigator": {
          "enabled": true,
          "scroll": {
            "enabled": true
          },
          "text": {
            "btnNextText": "<",
            "btnPrevText": ">"
          }
        },
        "toolbox": {
          "enabled": true,
          "calendarSwitch": {
            "enabled": false,
            "format": "MMMM"
          },
          "todayButton": {
            "enabled": true,
            "text": {
              "fa": "امروز",
              "en": "Today"
            }
          },
          "submitButton": {
            "enabled": false,
            "text": {
              "fa": "تایید",
              "en": "Submit"
            },
          },
          "text": {
            "btnToday": "امروز"
          }
        },
        "timePicker": {
          "enabled": false,
          "step": 1,
          "hour": {
            "enabled": true,
            "step": null
          },
          "minute": {
            "enabled": true,
            "step": null
          },
          "second": {
            "enabled": true,
            "step": null
          },
          "meridian": {
            "enabled": true
          }
        },
        "dayPicker": {
          "enabled": true,
          "titleFormat": "YYYY MMMM",
          "onSelect":	x=>{
            let p :Date= new Date(x);
            this.date = moment.utc([p.getFullYear(),p.getMonth(),p.getDate()]);
            this.date=moment(x).utc();
          }
        },
        "monthPicker": {
          "enabled": true,
          "titleFormat": "YYYY"
        },
        "yearPicker": {
          "enabled": true,
          "titleFormat": "YYYY"
        },
        "template": "\n<div id=\"plotId\" class=\"datepicker-plot-area " + (this.opentop ? "open-top" : "") + "  {{cssClass}}\">\n    {{#navigator.enabled}}\n        <div data-navigator class=\"datepicker-navigator\">\n            <div class=\"pwt-btn pwt-btn-next\">{{navigator.text.btnNextText}}</div>\n            <div class=\"pwt-btn pwt-btn-switch\">{{navigator.switch.text}}</div>\n            <div class=\"pwt-btn pwt-btn-prev\">{{navigator.text.btnPrevText}}</div>\n        </div>\n    {{/navigator.enabled}}\n    <div class=\"datepicker-grid-view\" >\n    {{#days.enabled}}\n        {{#days.viewMode}}\n        <div class=\"datepicker-day-view\" >    \n            <div class=\"month-grid-box\">\n                <div class=\"header\">\n                    <div class=\"title\"></div>\n                    <div class=\"header-row\">\n                        {{#weekdays.list}}\n                            <div class=\"header-row-cell\">{{.}}</div>\n                        {{/weekdays.list}}\n                    </div>\n                </div>    \n                <table cellspacing=\"0\" class=\"table-days\">\n                    <tbody>\n                        {{#days.list}}\n                           \n                            <tr>\n                                {{#.}}\n                                    {{#enabled}}\n                                        <td data-date=\"{{dataDate}}\" data-unix=\"{{dataUnix}}\" >\n                                            <span  class=\"{{#otherMonth}}other-month{{/otherMonth}}\">{{title}}</span>\n                                            {{#altCalendarShowHint}}\n                                            <i  class=\"alter-calendar-day\">{{alterCalTitle}}</i>\n                                            {{/altCalendarShowHint}}\n                                        </td>\n                                    {{/enabled}}\n                                    {{^enabled}}\n                                        <td data-date=\"{{dataDate}}\" data-unix=\"{{dataUnix}}\" class=\"disabled\">\n                                            <span class=\"{{#otherMonth}}other-month{{/otherMonth}}\">{{title}}</span>\n                                            {{#altCalendarShowHint}}\n                                            <i  class=\"alter-calendar-day\">{{alterCalTitle}}</i>\n                                            {{/altCalendarShowHint}}\n                                        </td>\n                                    {{/enabled}}\n                                    \n                                {{/.}}\n                            </tr>\n                        {{/days.list}}\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        {{/days.viewMode}}\n    {{/days.enabled}}\n    \n    {{#month.enabled}}\n        {{#month.viewMode}}\n            <div class=\"datepicker-month-view\">\n                {{#month.list}}\n                    {{#enabled}}               \n                        <div data-month=\"{{dataMonth}}\" class=\"month-item {{#selected}}selected{{/selected}}\">{{title}}</small></div>\n                    {{/enabled}}\n                    {{^enabled}}               \n                        <div data-month=\"{{dataMonth}}\" class=\"month-item month-item-disable {{#selected}}selected{{/selected}}\">{{title}}</small></div>\n                    {{/enabled}}\n                {{/month.list}}\n            </div>\n        {{/month.viewMode}}\n    {{/month.enabled}}\n    \n    {{#year.enabled }}\n        {{#year.viewMode }}\n            <div class=\"datepicker-year-view\" >\n                {{#year.list}}\n                    {{#enabled}}\n                        <div data-year=\"{{dataYear}}\" class=\"year-item {{#selected}}selected{{/selected}}\">{{title}}</div>\n                    {{/enabled}}\n                    {{^enabled}}\n                        <div data-year=\"{{dataYear}}\" class=\"year-item year-item-disable {{#selected}}selected{{/selected}}\">{{title}}</div>\n                    {{/enabled}}                    \n                {{/year.list}}\n            </div>\n        {{/year.viewMode }}\n    {{/year.enabled }}\n    \n    </div>\n    {{#time}}\n    {{#enabled}}\n    <div class=\"datepicker-time-view\">\n        {{#hour.enabled}}\n            <div class=\"hour time-segment\" data-time-key=\"hour\">\n                <div class=\"up-btn\" data-time-key=\"hour\">▲</div>\n                <input value=\"{{hour.title}}\" type=\"text\" placeholder=\"hour\" class=\"hour-input\">\n                <div class=\"down-btn\" data-time-key=\"hour\">▼</div>                    \n            </div>       \n            <div class=\"divider\">\n                <span>:</span>\n            </div>\n        {{/hour.enabled}}\n        {{#minute.enabled}}\n            <div class=\"minute time-segment\" data-time-key=\"minute\" >\n                <div class=\"up-btn\" data-time-key=\"minute\">▲</div>\n                <input disabled value=\"{{minute.title}}\" type=\"text\" placeholder=\"minute\" class=\"minute-input\">\n                <div class=\"down-btn\" data-time-key=\"minute\">▼</div>\n            </div>        \n            <div class=\"divider second-divider\">\n                <span>:</span>\n            </div>\n        {{/minute.enabled}}\n        {{#second.enabled}}\n            <div class=\"second time-segment\" data-time-key=\"second\"  >\n                <div class=\"up-btn\" data-time-key=\"second\" >▲</div>\n                <input disabled value=\"{{second.title}}\"  type=\"text\" placeholder=\"second\" class=\"second-input\">\n                <div class=\"down-btn\" data-time-key=\"second\" >▼</div>\n            </div>\n            <div class=\"divider meridian-divider\"></div>\n            <div class=\"divider meridian-divider\"></div>\n        {{/second.enabled}}\n        {{#meridian.enabled}}\n            <div class=\"meridian time-segment\" data-time-key=\"meridian\" >\n                <div class=\"up-btn\" data-time-key=\"meridian\">▲</div>\n                <input disabled value=\"{{meridian.title}}\" type=\"text\" class=\"meridian-input\">\n                <div class=\"down-btn\" data-time-key=\"meridian\">▼</div>\n            </div>\n        {{/meridian.enabled}}\n    </div>\n    {{/enabled}}\n    {{/time}}\n    \n    {{#toolbox}}\n    {{#enabled}}\n    <div class=\"toolbox\">\n        {{#toolbox.submitButton.enabled}}\n            <div class=\"pwt-btn-submit\">{{submitButtonText}}</div>\n        {{/toolbox.submitButton.enabled}}        \n        {{#toolbox.todayButton.enabled}}\n            <div class=\"pwt-btn-today\">{{todayButtonText}}</div>\n        {{/toolbox.todayButton.enabled}}        \n        {{#toolbox.calendarSwitch.enabled}}\n            <div class=\"pwt-btn-calendar\">{{calendarSwitchText}}</div>\n        {{/toolbox.calendarSwitch.enabled}}\n    </div>\n    {{/enabled}}\n    {{^enabled}}\n        {{#onlyTimePicker}}\n        <div class=\"toolbox\">\n            <div class=\"pwt-btn-exit\">{{text.btnExit}}</div>\n        </div>\n        {{/onlyTimePicker}}\n    {{/enabled}}\n    {{/toolbox}}\n</div>\n",
        "responsive": true,
      }
    }
    clear() {
      (<any>this.firstlevelElement.querySelector('#V-94722145-D490-4D17-A6F4-D141D696D7F6-selector')).value='';
      this.date = null;
    }
    onRenderCompleted(){
        let a = this.firstlevelElement.querySelector('#V-94722145-D490-4D17-A6F4-D141D696D7F6-selector');
        this._dateSelector = (<any>$(a)).persianDatepicker(this.getOptions());
        // this.setOptions();
    }
    public set allowclear(v: boolean) { this._allowclear = v; } public get allowclear(): boolean { return this._allowclear;} private _allowclear: boolean;

}
